import { z } from "zod";

export const RegisterSchema = z
  .object({
    name: z.string().min(3, "Name must be more than 3 characters"),
    icNumber: z.string().regex(/^\d{12}$/, "IC number must be 12 digits"),
    address: z.string().optional(),
    phoneNumber: z
      .string()
      .min(10, "Phone number must be 10 or 11 digits")
      .max(11, "Phone number must be 10 or 11 digits"),
    email: z.string().email("Invalid email"),
    role: z.enum(["client", "agent"]).default("client"),
    password: z
      .string()
      .min(8, "Password need to be more than 7 chars")
      .regex(
        /^(?=.*[a-z])(?=.*\d)[A-Za-z\d]{8,}$/,
        "Password must contain at least 1 letter and 1 number"
      ),
    branchId: z
      .string()
      .regex(/^[0-9a-fA-F]{24}$/, "Invalid branch ID")
      .optional(),
    agency: z.string().optional(),
    // confirmPassword: z.string().min(5, "Password need to be more than 5 chars"),
  })
  .refine(
    (data) => {
      // If role is agent, branchId is required
      if (data.role === "agent") {
        return !!data.branchId;
      }
      return true;
    },
    {
      message: "Required",
      path: ["branchId"],
    }
  )
  .refine(
    (data) => {
      // If role is agent, agency is required
      if (data.role === "agent") {
        return !!data.agency;
      }
      return true;
    },
    {
      message: "Required",
      path: ["agency"],
    }
  );
// .refine((data) => data.password === data.confirmPassword, {
//   message: "Passwords don't match",
//   path: ["confirmPassword"],
// });

export type IRegister = z.infer<typeof RegisterSchema>;
